import type { RouteRecordRaw } from 'vue-router'

export default {
	path: '/subscription',
	name: 'subscription',
	meta: {
		authRequired: true,
	},
	component: () => import('@/modules/plans/pages/SubscriptionPage.vue'),
} as RouteRecordRaw
